module.exports = __webpack_public_path__ + "static/media/hand-app.2677589f.png";